import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative flex items-center justify-center min-h-screen overflow-hidden">
        <div
          className="absolute inset-0 transform scale-110 bg-center bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url('${require('../../assets/update/About aureus - Hero Image.jpg')}')`
          }}
        />
        <div className="absolute inset-0 bg-black bg-opacity-60" />

        <div className="relative z-10 max-w-4xl px-4 mx-auto text-center text-white">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mb-2 text-base font-semibold tracking-widest text-white uppercase md:text-lg"
            style={{ letterSpacing: '0.18em' }}
          >
            Get to Know Us
          </motion.p>
          <motion.h1
            className="mb-6 text-5xl font-bold md:text-7xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            ABOUT <span className="text-yellow-400">AUREUS</span>
          </motion.h1>
          <motion.p
            className="mb-8 text-xl text-gray-200 md:text-2xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Where knowledge, character and faith grow together in harmony
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex flex-col items-center justify-center gap-4 sm:flex-row"
          >
            <Link
              to="/apply-online"
              className="inline-flex items-center justify-center w-full px-8 py-4 text-lg font-semibold text-black transition-colors duration-300 bg-yellow-400 rounded-full sm:w-auto hover:bg-yellow-500 group"
            >
              Apply Now
              <ChevronRightIcon className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center w-full px-8 py-4 text-lg font-semibold text-black transition-all duration-300 bg-yellow-400 border-2 border-yellow-400 rounded-full shadow-lg sm:w-auto hover:bg-yellow-500 hover:border-yellow-500"
            >
              Contact Us
            </Link>
          </motion.div>
        </div>
      </section>

      {/* About Content Section */}
      <section className="relative py-20 overflow-hidden bg-white">
        <div className="relative z-10 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="grid items-start gap-12 lg:grid-cols-2 min-h-[600px]">
            {/* Left: Text Content */}
            <div className="flex flex-col justify-start h-full">
              <h2 className="mb-3 text-3xl font-extrabold text-blue-900 md:text-4xl" style={{ fontFamily: 'Playfair Display, serif' }}>
                About Aureus Cambridge School
              </h2>
              <p className="mb-6 text-lg italic text-emerald-700">
                Where knowledge, character and faith grow together.
              </p>
              <p className="mb-6 text-lg text-slate-700">
                Aureus Cambridge School is a values driven institution offering the prestigious Cambridge curriculum alongside Islamic education. We believe children should grow not just in knowledge but in purpose, becoming leaders who excel both in this world and the next.
              </p>
              <div className="mb-6">
                <h3 className="mb-1 text-xl font-bold text-amber-600">Our Aim</h3>
                <p className="text-slate-700">
                  We aim to nurture confident, morally grounded learners who succeed in Dunyah O Akhirah. Our students are guided to live with purpose, compassion and a strong sense of identity.
                </p>
              </div>
              <div className="mb-6">
                <h3 className="mb-1 text-xl font-bold text-amber-600">Our Mission</h3>
                <p className="text-slate-700">
                  Our mission is to provide a transformative educational experience that blends academic excellence, Islamic tarbiyah and strong character development.
                </p>
              </div>
              <blockquote className="pl-4 mb-6 italic border-l-4 border-emerald-500 text-slate-600">
                “A community which guides by truth and thereby establishes justice.”<br />
                <span className="block mt-2 text-sm text-slate-400">— Surah Al-A‘raf 7:181</span>
              </blockquote>
              {/* Philosophy (optional) */}
              <div className="mt-6">
                <h3 className="mb-1 text-xl font-bold text-amber-600">Our Philosophy</h3>
                <p className="text-slate-700">
                  At Aureus, education goes beyond books. We focus on developing the whole child, mind, body and soul, through critical thinking, Qur'anic understanding, real world learning and adab (good manners).
                </p>
              </div>
            </div>
            {/* Right: Tree of Knowledge Image */}
            <div className="flex items-stretch h-full">
              <div className="relative w-full h-full">
                <img
                  src={require('../../assets/Tree of Knowledge.png')}
                  alt="Tree of Knowledge"
                  className="object-cover w-full h-full transition-transform duration-300 transform rounded-2xl hover:scale-105"
                  style={{ minHeight: '500px' }}
                />
                <div className="absolute transform -translate-x-1/2 bottom-4 left-1/2">
                  <span className="px-4 py-2 text-sm font-medium rounded-full shadow-lg bg-white/90 backdrop-blur-sm text-emerald-700">
                    Tree of Knowledge
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 